
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";
import { defineComponent } from "vue";

import MasterPricing from "@/components/1crm/fitur/management-harga/index.vue";

export default defineComponent({
  name: "kt-widget-11",
  components: {
    MasterPricing,
  },
  props: {
    widgetClasses: String,
  },
  beforeMount() {
    store.dispatch(Actions.VERIFY_AUTH_USER);
    setCurrentPageBreadcrumbs("Management Harga", ["Management Fitur"]);
  },
});
